import React from 'react';
import { FormattedMessage } from 'react-intl';

import { NotificationService, NOTIFICATION_TYPE_SUCCESS, NOTIFICATION_TYPE_ERROR } from 'ui-components/services/notification-service';

import messages from '../../messages';

/**
 * @typedef {import('../../../../../prop-types/intl-types').MessageDescriptor} MessageDescriptor
 */

/**
 * Error Notification with 3s duration
 * @param {MessageDescriptor} messageDescriptor
 */
export const showErrorNotification = (messageDescriptor) => {
  NotificationService.showNotification({
    title: '',
    notificationType: NOTIFICATION_TYPE_ERROR,
    content: <FormattedMessage {...messageDescriptor} />,
    duration: 3000,
  });
};

/**
 * Success Notification with 3s duration
 * @param {MessageDescriptor} messageDescriptor
 */
export const showSuccessNotification = (messageDescriptor) => {
  NotificationService.showNotification({
    title: '',
    notificationType: NOTIFICATION_TYPE_SUCCESS,
    content: <FormattedMessage {...messageDescriptor} />,
    duration: 3000,
  });
};

/**
 * Displays a present-until-dismissed notification with the provided externalAccountName
 * @param {string} externalAccountName
 */
export const showAccountLinkingSuccessNotification = (externalAccountName) => {
  NotificationService.showNotification({
    notificationType: NOTIFICATION_TYPE_SUCCESS,
    title: <FormattedMessage {...messages.connectAccountSuccessTitle} values={{ externalAccountName }} />,
    content: <FormattedMessage {...messages.connectAccountSuccessMsg} values={{ externalAccountName }} />,
    dontHide: true,
  });
};
